import { createSlice } from '@reduxjs/toolkit';

export const SESSION_STATUS = {
  ACTIVE: 'active',
  LOGGING_OUT: 'logging_out',
  ENDED: 'ended',
};

// Etat d'authentification centralisé dans Redux
const initialState = {
  currentUser: null,
  roles: [],
  loading: true,
  error: null,
  sessionStatus: SESSION_STATUS.ACTIVE,
  logoutReason: null,
  refreshUnavailable: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      if (state.sessionStatus !== SESSION_STATUS.ACTIVE) return;
      state.currentUser = action.payload;
      state.error = null;
    },
    clearCurrentUser(state) {
      state.currentUser = null;
      state.roles = [];
      state.error = null;
    },
    setCurrentUserLoading(state, action) {
      if (state.sessionStatus !== SESSION_STATUS.ACTIVE) return;
      state.loading = Boolean(action.payload);
    },
    setCurrentUserError(state, action) {
      if (state.sessionStatus !== SESSION_STATUS.ACTIVE) return;
      state.error = action.payload ?? 'unknown_error';
    },
    updateUserFields(state, action) {
      if (!state.currentUser) return;
      state.currentUser = { ...state.currentUser, ...action.payload };
    },
    setRoles(state, action) {
      if (state.sessionStatus !== SESSION_STATUS.ACTIVE) return;
      state.roles = Array.isArray(action.payload) ? action.payload : [];
    },
    clearRoles(state) {
      state.roles = [];
    },
    setSessionRefreshUnavailable(state, action) {
      if (state.sessionStatus !== SESSION_STATUS.ACTIVE) return;
      state.refreshUnavailable = Boolean(action.payload);
    },
    startSessionLogout(state, action) {
      state.sessionStatus = SESSION_STATUS.LOGGING_OUT;
      state.logoutReason = action.payload ?? null;
      state.currentUser = null;
      state.roles = [];
      state.loading = false;
      state.error = null;
      state.refreshUnavailable = false;
    },
    finishSessionLogout(state) {
      state.sessionStatus = SESSION_STATUS.ENDED;
    },
  },
});

export const {
  setCurrentUser,
  clearCurrentUser,
  setCurrentUserLoading,
  setCurrentUserError,
  updateUserFields,
  setRoles,
  clearRoles,
  setSessionRefreshUnavailable,
  startSessionLogout,
  finishSessionLogout,
} = authSlice.actions;

export default authSlice.reducer;
